import { CONFIG } from '../config'
import { LoginInfoModel, UserModel } from '../models'
import client from './base'

export type ILoginRequest = {
    mEmail: string
    mPassword: string
}

export const login = async (payload: ILoginRequest): Promise<LoginInfoModel> => {
    return await client.post(`${process.env.REACT_APP_API_BASE_URL}/admin/signin/basic`, payload).then(res => {
        const { loginSession, userInfo } = res?.data

        return {
            loginSession,
            doctor: new UserModel(userInfo)
        } as LoginInfoModel
    })
}

export const setAccountInfo = (accountInfo: LoginInfoModel) => {
    localStorage.setItem(CONFIG.ACCOUNT_INFO_FIELD, JSON.stringify(accountInfo))
}

export const getAccountInfo = () => {
    const accountInfo: any = localStorage.getItem(CONFIG.ACCOUNT_INFO_FIELD)

    return JSON.parse(accountInfo) as LoginInfoModel
}

export const isAdmin = () => {
    const account = getAccountInfo()
    return account.loginSession.userLocalType === "ADMIN"
}

export const setFlow = (flow: string) => {
    localStorage.setItem(CONFIG.FLOW, flow)
}

export const getFlow = () => {
    return localStorage.getItem(CONFIG.FLOW)
}

export const clearFlow = () => {
    localStorage.removeItem(CONFIG.FLOW)
}